import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Headers from './Component/Header';
import Footer from './Component/Footer';
import Request from './Component/requestEstimate';
import home5 from './Component/product/hardware1.png';
import d1 from './Component/d4.png';
import d2 from './Component/d2.png';
import d3 from './Component/d5.png';
import d6 from './Component/d6.png';
import brand1 from './Component/home/brand1.png';
import brand2 from './Component/home/brand2.png';

function BuilderProgram() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <Headers />

      <section
        className="relative bg-cover bg-center"
        style={{ backgroundImage: `url(${home5})` }}
      >
        <div className="absolute inset-0 bg-[#803333]/80" />
        <div className="relative container mx-auto px-4 py-14 md:py-20 text-center text-white">
          <h1 className="text-3xl md:text-4xl font-bold mb-2 tracking-tight">
            Builder & Contractor Program
          </h1>
          <p className="text-white/85 text-sm md:text-base mb-6 max-w-xl mx-auto">
            Partner with Nickle&apos;s Flooring for new construction and full home remodels
          </p>
          <a
            href="/free-estimate"
            className="inline-flex items-center gap-2 bg-white text-[#803333] font-semibold text-sm px-5 py-2.5 rounded-lg no-underline hover:bg-white/90 transition-colors"
          >
            Schedule Today
            <i className="bi bi-arrow-right" />
          </a>
        </div>
      </section>

      <section className="container mx-auto px-4 py-10 md:py-14">
        <div className="row g-4">
          {[d1, d2, d3].map((img, index) => (
            <div key={index} className="col-md-4">
              {index === 1 ? (
                <a href="tel:+14178472484" className="block overflow-hidden rounded-2xl border-2 border-[#803333] shadow-sm hover:shadow-md transition-shadow">
                  <img src={img} alt="Call Nickle's Flooring" className="w-full h-auto d-block" />
                </a>
              ) : (
                <div className="overflow-hidden rounded-2xl border-2 border-[#803333] shadow-sm">
                  <img src={img} alt="Builder and contractor program" className="w-full h-auto d-block" />
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      <section className="container mx-auto px-4 pb-10 md:pb-14">
        <div className="row g-4 g-lg-5 align-items-start">
          <div className="col-lg-6">
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
              <Request />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 md:p-6">
              <img
                src={d6}
                alt="Builder program details"
                className="w-full h-auto rounded-xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white border-t border-gray-100 py-10 md:py-14">
        <div className="container mx-auto px-4">
          <h2 className="text-xl md:text-2xl font-bold text-center text-gray-900 mb-8">
            Featured brands & technologies
          </h2>
          <div className="space-y-6">
            <img src={brand1} alt="Featured flooring brands" className="mx-auto d-block max-w-full h-auto" />
            <img src={brand2} alt="Featured flooring technologies" className="mx-auto d-block max-w-full h-auto" />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default BuilderProgram;
